import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Shop icon
const shopIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
  iconSize: [35, 35],
  iconAnchor: [17, 35],
  popupAnchor: [0, -35]
});

// User location icon
const userIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30]
});

// Component to update map view when userLocation changes
function MapUpdater({ userLocation }) {
  const map = useMap();
  
  useEffect(() => {
    if (userLocation) {
      map.setView([userLocation.lat, userLocation.lng], 13);
    }
  }, [map, userLocation]);

  return null;
}

function LocationMapEvents({ onLocationSelect }) {
  useMapEvents({
    click(e) {
      onLocationSelect(e.latlng);
    },
  });
  return null;
}

function LocationPicker({ onLocationSelect, userLocation, shopLocation }) {
  const [map, setMap] = useState(null);
  
  // Default center (Sri Lanka)
  const sriLankaCenter = [7.8731, 80.7718];

  // Initial view depends on whether we have user location
  const initialCenter = userLocation ? [userLocation.lat, userLocation.lng] : sriLankaCenter;
  const initialZoom = userLocation ? 13 : 8;

  return (
    <div className="location-picker">
      <MapContainer
        center={initialCenter}
        zoom={initialZoom}
        style={{ height: '400px', width: '100%' }}
        whenCreated={setMap}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        
        {/* Shop Location Marker */}
        <Marker position={shopLocation} icon={shopIcon}>
          <Popup>
            <strong>🏪 Our Shop</strong>
            <br />
            Delivery starting point
            <br />
            <small>Maharagama</small>
          </Popup>
        </Marker>

        {/* User Location Marker */}
        {userLocation && (
          <Marker position={userLocation} icon={userIcon}>
            <Popup>
              <strong>📍 Your Location</strong>
              <br />
              Click anywhere to change
            </Popup>
          </Marker>
        )}

        <LocationMapEvents onLocationSelect={onLocationSelect} />
        <MapUpdater userLocation={userLocation} />
      </MapContainer>
    </div>
  );
}

export default LocationPicker;